import styled from "styled-components";

export const StyledProduct = styled.div`
    ${props => props.brand && `
        .product-name-category-box .product-category {
            background:  ${props.brand.colors.supporting} !important;
            color: ${props.brand.colors.black} !important;
        }
    `}
`;